import "./Header.scss";
import ButtonOutline from "./ButtonOutline";

import HeaderLogo from "../../assets/images/header-logo.png";
import { HambergerMenu, Add } from "iconsax-react";
import { useState } from "react";

export default function Header() {
	const [sidebarActive, setSidebarActive] = useState(false);

	const toggleSidebar = () => {
		setSidebarActive(!sidebarActive);
	};

	const closeSidebar = () => {
		setSidebarActive(false);
	};

	const handleScroll = (e) => {
		e.preventDefault(); // Prevent default anchor behavior

		try {
			closeSidebar();
			const target = e.target.getAttribute("href");
			const targetElement = document.querySelector(target);
			const headerHeight = document.querySelector(".header").offsetHeight;

			const yOffset = -headerHeight; // Negative offset to account for the header
			const yPosition =
				targetElement.getBoundingClientRect().top +
				window.pageYOffset +
				yOffset;

			window.scrollTo({ top: yPosition, behavior: "smooth" });
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<div className="header">
			<div className="header-content content-wrapper-lg">
				<div className="header-left">
					<a href="#-" className="header-logo-link">
						<img
							className="header-logo"
							src={HeaderLogo}
							alt="Header Logo"
							width="92"
							height="105"
						/>
					</a>

					<a className="header-btn logo-btn" href="#-">
						<img
							src={HeaderLogo}
							alt="Header Logo Btn"
							width={24}
							height={24}
						/>
					</a>

					<nav className="header-nav">
						<ul>
							<li>
								<a href="#heading" onClick={handleScroll}>
									Heading
								</a>
							</li>
							<li>
								<a href="#our-features" onClick={handleScroll}>
									About
								</a>
							</li>
							<li>
								<a href="#roadmap" onClick={handleScroll}>
									RoadMap
								</a>
							</li>
							<li>
								<a href="#contact-us" onClick={handleScroll}>
									Community
								</a>
							</li>
							<li>
								<a href="#footer" onClick={handleScroll}>
									Contact
								</a>
							</li>
						</ul>
					</nav>
				</div>

				<div className="header-right">
					<ButtonOutline className="launch-app-btn">
						Get Started
					</ButtonOutline>
					<button
						className="header-btn mobile-sidebar-btn"
						onClick={toggleSidebar}
					>
						<HambergerMenu size="24" color="#ffffff" />
					</button>
				</div>
			</div>

			{/* Sidebar Implementation */}
			<div
				className={`sidebar-backdrop ${sidebarActive ? "active" : ""}`}
				onClick={closeSidebar}
			></div>
			<div className={`sidebar ${sidebarActive ? "active" : ""}`}>
				<div className="sidebar-content">
					<div className="sidebar-header">
						<button
							className="sidebar-close"
							onClick={closeSidebar}
						>
							<Add
								size="40"
								color="#808080"
								className="add-icon"
							/>
						</button>
					</div>

					<div className="sidebar-body">
						<ul className="sidebar-nav">
							<li>
								<a href="#heading" onClick={handleScroll}>
									Heading
								</a>
							</li>
							<li>
								<a href="#our-features" onClick={handleScroll}>
									About
								</a>
							</li>
							<li>
								<a href="#roadmap" onClick={handleScroll}>
									RoadMap
								</a>
							</li>
							<li>
								<a href="#contact-us" onClick={handleScroll}>
									Community
								</a>
							</li>
							<li>
								<a href="#footer" onClick={handleScroll}>
									Contact
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			{/* End of Sidebar */}
		</div>
	);
}
